import { ReferralStepsBullets } from "./components/social-referral-page-bullets/social-referral-page-bullets.component";
import { SocialReferralFooter } from "./components/social-referral-page-footer/social-referral-page-footer.component";
import { SocialReferralHeader } from "./components/social-referral-page-header/social-referral-page-header.component";
import { SocialReferralSubHeader } from "./components/social-referral-page-subheader/social-referral-page-subheader.component";

declare global {
  interface FKL {
    pageMetafields: Record<string, string>;
    pageHandle: string;
  }
}

export function Widget() {
  return (
    <div className="social-referral-page">
      <div className="social-referral-page__header">
        <SocialReferralHeader />
      </div>
      <div className="social-referral-page__body">
        <SocialReferralSubHeader />
        <ReferralStepsBullets />
      </div>
      <div className="social-referral-page__footer">
        <SocialReferralFooter />
      </div>
    </div>
  );
}
